import React, { FC } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { SCUIToast } from '../../atoms';
import { enumSnackbarStatusType } from '../../../types/enums';
import './SCUISnackbar.scss';

interface IProps {
    show?: boolean;
    onClose?: () => void;
    onShow?: () => void;
    messageText?: string;
    key?: string;
    status:
        | enumSnackbarStatusType.success
        | enumSnackbarStatusType.warning
        | enumSnackbarStatusType.danger
        | enumSnackbarStatusType.info;
    autoHideDuration?: number;
}

const SnackbarContent = React.forwardRef<HTMLDivElement, { status: string; text: string }>(({ status, text }, ref) => (
    <div ref={ref}>
        <SCUIToast type={status} text={text} />
    </div>
));

export const SCUISnackbar: FC<IProps> = ({
    show,
    messageText = '',
    status = enumSnackbarStatusType.success,
    onClose,
    autoHideDuration = 2500,
}) => {
    const handleClose = (_event: any, reason?: string) => {
        if (reason === 'clickaway') return;
        onClose?.();
    };

    return (
        <Snackbar
            key={messageText}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            className="sc-snackbar"
            open={show}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
        >
            <SnackbarContent status={status} text={messageText} />
        </Snackbar>
    );
};
